import AgentRolloverBurst from '~/components/v2/components/workspace/workspace-agent-panel/animations/AgentRolloverBurst.json';

/** Strato agent entry wordmark — `AgentRolloverBurst` (800² comp, frames 0–91). */
export const WORKSPACE_AGENT_AIR_MARK_IN_POINT = 0;
export const WORKSPACE_AGENT_AIR_MARK_OUT_POINT = 91;

/** lottie-web frame arguments are relative to the baked `ip`. */
export const WORKSPACE_AGENT_AIR_MARK_DRAWN_FRAME =
  WORKSPACE_AGENT_AIR_MARK_OUT_POINT - WORKSPACE_AGENT_AIR_MARK_IN_POINT;

/** Crop to the script A plus stroke padding for `size-4` prefixes and CTAs. */
export const WORKSPACE_AGENT_AIR_MARK_VIEW_BOX = '50 140 560 560';

export const WORKSPACE_AGENT_AIR_MARK_ANIMATION_DATA = {
  ...AgentRolloverBurst,
  ip: WORKSPACE_AGENT_AIR_MARK_IN_POINT,
  op: WORKSPACE_AGENT_AIR_MARK_OUT_POINT,
};

export const WORKSPACE_AGENT_AIR_MARK_RENDERER_SETTINGS = { viewBoxSize: WORKSPACE_AGENT_AIR_MARK_VIEW_BOX };
